import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import styles from "./loginModal.module.css";

const LoginModal = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const {
    isLoginModalOpen,
    closeLoginModal,
    signInWithUsername,
    usernameDomain,
    postLoginPath,
    isAdmin,
  } = useAuth();
  const navigate = useNavigate();

  const resetForm = () => {
    setUsername("");
    setPassword("");
    setErrorMessage("");
    setSubmitting(false);
  };

  useEffect(() => {
    if (isLoginModalOpen) {
      resetForm();
    }
  }, [isLoginModalOpen]);

  const handleClose = () => {
    resetForm();
    closeLoginModal();
  };

  if (!isLoginModalOpen) {
    return null;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setErrorMessage("");

    const { error } = await signInWithUsername(username, password);

    if (error) {
      setErrorMessage("Unable to sign in. Please check your username and password.");
      setSubmitting(false);
      return;
    }

    const fallbackPath = isAdmin ? "/admin" : "/portal";
    navigate(postLoginPath || fallbackPath, { replace: true });
    setSubmitting(false);
  };

  return (
    <div className={styles.overlay} onClick={handleClose}>
      <section className={styles.modal} onClick={(event) => event.stopPropagation()}>
        <button type="button" className={styles.closeButton} onClick={handleClose}>
          x
        </button>
        <h1>Sign In</h1>
        <p className={styles.hint}>
          Expected login: <strong>username</strong> (converted to{" "}
          <code>username@{usernameDomain}</code>)
        </p>

        <form onSubmit={handleSubmit} className={styles.form}>
          <label htmlFor="username">Username</label>
          <input
            id="username"
            type="text"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            autoComplete="username"
            required
          />

          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            required
          />

          {errorMessage && <p className={styles.error}>{errorMessage}</p>}

          <button type="submit" disabled={submitting}>
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </section>
    </div>
  );
};

export default LoginModal;
